// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.links-to-events--text{font-size:20px;margin-bottom:0;padding-bottom:1rem}.links-to-events--link{margin:0}.links-to-events--link~.links-to-events--link{margin-top:.5rem}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
